import React, { useEffect, useState, forwardRef } from "react";
import {
  Box,
  Button,
  Link,
  Text,
  Flex,
  ButtonGroup,
  useDisclosure,
  useBreakpointValue
} from "@chakra-ui/react";
import {
  Card, CardHeader, CardTitle, Right, CardContent
} from "../../../../components/Card";
import {BsArrowUp} from "react-icons/bs";
import {stateColors} from "../../../../components/States"
import {AddIcon} from "@chakra-ui/icons";

import InfoBox from "../../../../components/InfoBox"
import CreateTaskModal from "./modals/CreateTaskModal";
import CreateBulkTaskModal from "./modals/CreateBulkTaskModal";
import CreateSubtaskModal from "./modals/CreateSubtaskModal";
import TaskDetailModal from "./modals/Task";

import AssingTaskModal from "./modals/AssingTaskModal";
import AssingTaskTypeModal from "./modals/AssingTaskTypeModal";

import urlToId from "../../../../helpers/UrlToId";
import formatDateTable from "../../../../helpers/FormatDateTable";

import {translateState, translateKind} from "../../../../shared/libs/translate";

const maxTextLength = 100;

/* TODO: We should move this somewhere else. It's circular import between 
   Tasks.jsx and Task.jsx */
export const SubModalType = {
  APPOINTMENT: 'appointment',
  SERVICE: 'service',
  NONE: null
};

const Tasks = forwardRef((props, ref) => {
  const {tasks, ticketURL, resellerID, ticketRevalidator, ticketRendered, initialSelectedTaskID, ticketRef} = props;
  const [selectedTaskID, setSelectedTaskID] = useState(initialSelectedTaskID);
  const [assigningTask, setAssigningTask] = useState(null);
  const [typeSelectingTask, setTypeSelectingTask] = useState(null);
  const createTaskModalState = useDisclosure();
  const createBulkTaskModalState = useDisclosure();
  const createSubtaskModalState = useDisclosure();
  const assignTaskModalState = useDisclosure();
  const assignTaskTypeModalState = useDisclosure();
  const taskDetailDrawerState = useDisclosure();
  const [activeSubModal, setActiveSubModal] = useState(SubModalType.NONE);
  const [parentTaskForSubtask, setParentTaskForSubtask] = useState(null);

  useEffect(() => {
    if (selectedTaskID) {
      taskDetailDrawerState.onOpen();
    }
  }, [initialSelectedTaskID, taskDetailDrawerState, selectedTaskID]);
  const handleTaskOpen = (task) => {
    setSelectedTaskID(urlToId(task.url));
    taskDetailDrawerState.onOpen();
  };
  const handleTaskClose = () => {
    setSelectedTaskID(null);
    taskDetailDrawerState.onClose()
  }
  const handleAssign = (task) => {
    setAssigningTask(task);
    assignTaskModalState.onOpen();
  };
  const handleSetType = (task) => {
    setTypeSelectingTask(task);
    assignTaskTypeModalState.onOpen();
  };
  const handleSetAppointment = (task) => {
    setActiveSubModal(SubModalType.APPOINTMENT);
  };
  const handleSetService = (task) => {
    setActiveSubModal(SubModalType.SERVICE);
  };
  const handleCreateSubtask = (task) => {
    setParentTaskForSubtask(task);
    createSubtaskModalState.onOpen();
  };
  const infoBoxDir = useBreakpointValue({
    'xl': 'column',
    'md': 'row'
  });
  const taskDir = useBreakpointValue({
    'xl': 'row',
    'md': 'column'
  })
  const handleScrollToTicket = () => {
    ticketRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <Box ref={ref}>
      <Card>
       
        <CardContent>
          <Flex flexDir={'column'}>
            {tasks && tasks.filter(task => !task.parent_task).map((task, i) => (
              <Box key={'task-'+i}>
                <Flex flexDir={taskDir} gap={2} fontSize='md' pb={4} mb={4} borderBottomWidth={1} borderBottomStyle={'dashed'} borderColor='gray.300'>
                  <Box flexGrow={1}>
                    <Text fontWeight={600} mb={2}>
                      <Link onClick={() => handleTaskOpen(task)}>Alt Görev #{task.number}</Link>
                    </Text>
                    <Text>{task.title.length > maxTextLength ? task.title.slice(0, maxTextLength) + "..." : task.title}</Text>
                    <Button size="xs" mt={2} colorScheme="blue" variant="outline" onClick={() => handleCreateSubtask(task)}>
                      Alt Görev Ekle
                    </Button>
                  </Box>
                  <Flex flexDir={infoBoxDir} columnGap={2} rowGap={1} flexWrap={'wrap'}>
                    <InfoBox title='Görev Tipi:' value={translateKind(task.kind)} noBg={false} fontSize={'sm'}/>
                    <InfoBox title='Oluşturulma:' value={formatDateTable(task.created_at)} noBg={false} fontSize={'sm'}/>
                    { task.appointment_date && <InfoBox title='Randevu:' value={formatDateTable(task.appointment_date)} noBg={false} fontSize={'sm'}/>}
                    {task.assigned_to && <InfoBox title='Takım:' value={`${task.assigned_to?.name}${task.assigned_to?.reseller?.name ? ` (${task.assigned_to.reseller.name})` : ''}`} noBg={false} fontSize={'sm'}/>}
                    {task.assigned_user && <InfoBox title='Kullanıcı:' value={`${task.assigned_user?.full_name || task.assigned_user?.username}${task.assigned_user?.employee?.reseller?.name ? ` (${task.assigned_user.employee.reseller.name})` : ''}`} noBg={false} fontSize={'sm'}/>}
                    {!task.assigned_to && !task.assigned_user && <InfoBox title='Atama:' value='Atanmamış' noBg={false} fontSize={'sm'}/>}
                    <InfoBox title='Durum:' bg={stateColors[task.state]} color='gray.100' value={translateState(task.state)} noBg={false} fontSize='sm' />
                  </Flex>
                </Flex>
                {/* Alt görevleri göster */}
                {tasks.filter(subtask => subtask.parent_task && urlToId(subtask.parent_task) === task.id).map((subtask, j) => (
                  <Flex key={'subtask-'+j} flexDir={taskDir} gap={2} fontSize='sm' pb={3} mb={3} ml={6} pl={4} borderLeftWidth={2} borderLeftColor='red.200' bg='blue.50' borderRadius='md'>
                    <Box flexGrow={1}>
                      <Text fontWeight={500} mb={1}>
                        <Link onClick={() => handleTaskOpen(subtask)}>↳ Alt Görev #{subtask.number}</Link>
                      </Text>
                      <Text fontSize='sm'>{subtask.title.length > maxTextLength ? subtask.title.slice(0, maxTextLength) + "..." : subtask.title}</Text>
                    </Box>
                    <Flex flexDir={infoBoxDir} columnGap={2} rowGap={1} flexWrap={'wrap'}>
                      <InfoBox title='Tip:' value={translateKind(subtask.kind)} noBg={false} fontSize={'xs'}/>
                      <InfoBox title='Oluşturulma:' value={formatDateTable(subtask.created_at)} noBg={false} fontSize={'xs'}/>
                      {subtask.assigned_to && <InfoBox title='Takım:' value={`${subtask.assigned_to?.name}${subtask.assigned_to?.reseller?.name ? ` (${subtask.assigned_to.reseller.name})` : ''}`} noBg={false} fontSize={'xs'}/>}
                      {subtask.assigned_user && <InfoBox title='Kullanıcı:' value={`${subtask.assigned_user?.full_name || subtask.assigned_user?.username}${subtask.assigned_user?.employee?.reseller?.name ? ` (${subtask.assigned_user.employee.reseller.name})` : ''}`} noBg={false} fontSize={'xs'}/>}
                      <InfoBox title='Durum:' bg={stateColors[subtask.state]} color='gray.100' value={translateState(subtask.state)} noBg={false} fontSize='xs' />
                    </Flex>
                  </Flex>
                ))}
              </Box>
            ))}
          </Flex>
        </CardContent>
      </Card>
      <CreateTaskModal
        ticketURL={ticketURL}
        resellerID={resellerID}
        state={createTaskModalState}
        ticketRevalidator={ticketRevalidator}
      />
      <CreateBulkTaskModal
        ticketURL={ticketURL}
        resellerID={resellerID}
        state={createBulkTaskModalState}
        ticketRevalidator={ticketRevalidator}
      />
      <CreateSubtaskModal
        parentTaskId={parentTaskForSubtask?.id}
        ticketURL={ticketURL}
        resellerID={resellerID}
        state={createSubtaskModalState}
        ticketRevalidator={ticketRevalidator}
      />
      <AssingTaskModal
        task={assigningTask}
        resellerID={resellerID}
        ticketRevalidator={ticketRevalidator}
        assignTaskModalState={assignTaskModalState}
      />
      <AssingTaskTypeModal
        task={typeSelectingTask}
        state={assignTaskTypeModalState}
        revalidator={ticketRevalidator}
      />
      {/* TODO: This is not a drawer anymore. Rename it */}
      <TaskDetailModal
        taskID={selectedTaskID}
        revalidator={ticketRevalidator}
        handleClose={handleTaskClose}
        handleAssign={handleAssign}
        handleSetType={handleSetType}
        handleSetAppointment={handleSetAppointment}
        handleSetService={handleSetService}
        handleCreateSubtask={handleCreateSubtask}
        ticketRendered={ticketRendered}
        ticketRevalidator={ticketRevalidator}
        disclosure={taskDetailDrawerState}
        activeSubModal={activeSubModal}
        setActiveSubModal={setActiveSubModal}
      />
    </Box>
  );
});

export default Tasks;
